import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { ADModalBody, ADModalBodyNoScroll, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { closeWindow, ManagedWindow, openWindow, WindowId } from "src/WindowManager/WindowState";
import { CompactJobStatus, JobServiceInterface, JobStatus, ServiceStatus } from "./JobServiceInterface";
import { ViewButtonCheck, ViewButtonDropdown, ViewButtonText, ViewButtonTextInput } from "src/propertyInfoTemplates/PropertyComponents";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { GlassButton, GlassButtonDropdown, GlassButtonRow } from "src/components/GlassButtons";
import { ExportData } from "src/managers/ExportData";
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";
import { Localization, SessionContext } from "@viamap/viamap2-common";
import { JobActionType, JobsContext } from "./JobState";
import { GlassContainer, GlassInfo } from "src/components/MitGlassComponents";
import { JobInstantiateDialog } from "./JobInstantiateDialog";
import { actionAddDataLayer, MapitStateContext } from "src/states/MapitState";
import { Persistence } from "src/managers/Persistence";
import { LayerFunc } from "src/managers/LayerFunc";
import { featureCollection } from "@turf/helpers";
import { LayerInfo, LayerInfoStyling } from "src/common/managers/Types";
import Spinner from "react-bootstrap/esm/Spinner";
import { RejseplanRoute } from "./RejseplanRute";
import { transporttypeColor } from "./TransportTypeUtils";
import { JsonViewer } from "./JsonViewer";
import { ArrowRotateLeft, Refresh } from "iconsax-react";

//#region Job Service Window

export function JobserviceInsiderWindow(props: { window: ManagedWindow }) {
   const { state: sessionState } = useContext(SessionContext);
   const { hasAccessToFeature } = useContext(ApplicationStateContext);
   const { dispatch: jobStateDispatch } = useContext(JobsContext);

   const [servicStatus, setServiceStatus] = useState<ServiceStatus | boolean>(false);
   const [globalAdmin, setGlobalAdmin] = useState(false);
   const [jobService] = useState<JobServiceInterface>(new JobServiceInterface({
      organizationId: sessionState.customerRef,
      userName: sessionState.userName,
      userRef: sessionState.userRef,
      languageCode: Localization.getLanguage() as "da" | "en"
   }));
   const [refresh, setRefresh] = useState(0);
   const { dispatch: windowDispath } = useWindowContext();

   useEffect(() => {
      jobStateDispatch({ type: JobActionType.LoadJobTypes });
   }, []);

   useEffect(() => {
      if (props.window.state === "open") {
         var acceptStatus = true;
         function getServiceStatus() {
            jobService.serviceStatus().catch(() => {
               acceptStatus && setServiceStatus(true);
            }).then((status) => {
               if (status) {
                  acceptStatus && setServiceStatus(status);
               } else {
                  acceptStatus && setServiceStatus(true);
               }
            }).catch((err) => {
               console.error(err);
               acceptStatus && setServiceStatus(true);
            })

         }
         getServiceStatus();
         let interval = setInterval(getServiceStatus, 60000);
         return () => {
            acceptStatus = false;
            clearInterval(interval);
         }
      }
   }, [props.window.state, refresh])


   return (<AdvancedDragModal window={props.window}
      allowUserMiniMize={true}
      onClose={() => windowDispath(closeWindow(props.window.id))}
      PosDefault={{ left: "100px", top: "10%", width: "750px", height: "750px" }}
      title={Localization.getText("Job Service")}
      subHeaderContent={
         <>
            {
               hasAccessToFeature(Feature.JobModuleGlobalAdmin) ?
                  <ViewButtonCheck checked={!!globalAdmin} onCheck={() => { setGlobalAdmin((a) => !a) }} >Admin</ViewButtonCheck>
                  : <></>
            }
            {globalAdmin ? <ViewButtonText onClick={() => setRefresh((a) => a + 1)}>{typeof servicStatus !== "boolean" ? new Date(servicStatus.started).toLocaleString() : "Refresh (Down)"}</ViewButtonText> : <></>}
            <ViewButtonText onClick={async (val) => {
               // await JobService.CreateJob(val, "ukendt");
               // setRefresh(a => a + 1);
               windowDispath(openWindow(WindowId.JobServiceJobCreator, {
                  jobType: val, callback: () => {
                     setRefresh(a => a + 1);
                  }
               }));
            }} >{Localization.getText("Create job")}</ViewButtonText>
            {/* <ViewButtonCaret onClick={() => windowDispath(openWindow(WindowId.JobServiceLog, {}))} isOpen={false} >Logs</ViewButtonCaret> */}
            {globalAdmin ? <ViewButtonText onClick={async () => { await jobService.StopServer(); setRefresh(a => a + 1) }}>Restart</ViewButtonText> : <></>}
         </>
      }
   >
      <ADModalBody>
         {servicStatus === true ? <div ><GlassInfo>
            <span style={{ textAlign: "center", color: "darkred" }} >
               {Localization.getText("Cannot connect to the required service")}
            </span>
            <br />
            <GlassButton style={{ fontSize: "1em", margin: "0.2em" }} onClick={() => {
               setServiceStatus(false);
               setRefresh((a) => a + 1);
            }}><ArrowRotateLeft size={"1em"} /> {Localization.getText("Try again")}</GlassButton>
            <br />
            {Localization.getText("con:Or")}
            <br />
            <span>
               <a href="mailto:support@viamap.net">Viamap support</a>
            </span>
         </GlassInfo></div > : <></>}
         <JobList parentRefresh={refresh} jobService={jobService} admin={globalAdmin} />
      </ADModalBody>
   </AdvancedDragModal>)
}

//#region Job List

function JobList(props: { parentRefresh: number, jobService: JobServiceInterface, admin: boolean }) {
   const [jobList, setJobList] = useState<CompactJobStatus[] | null>();
   const [refresh, setRefresh] = useState(0);

   useEffect(() => {
      props.jobService.JobStatus(props.admin ? "admin" : "user").then((status) => {
         setJobList(status.toReversed());
      });
   }, [refresh, props.parentRefresh, props.admin]);


   return (
      <div style={{ paddingInline: "20px" }}>
         {jobList?.map((job) => (
            <JobDetail key={job.id} job={job} jobService={props.jobService} admin={props.admin} callBack={() => setRefresh((a) => a + 1)} />
         ))}
         {jobList?.length === 0 ? <GlassInfo style={{ color: "darkred" }} >{Localization.getText("No jobs")}</GlassInfo> : <></>}
      </div>
   )
}

//#region Job Detail

function JobDetail(props: { job: CompactJobStatus, jobService: JobServiceInterface, admin: boolean, callBack?: () => void }) {
   const { state: sessionState } = useContext(SessionContext)
   const [jobStatus, setJobStatus] = useState<JobStatus | null>(null);
   const [download, setDownload] = useState<string[]>([]);
   const [taskListAccess, setTaskListAccess] = useState(false);
   const [refresh, setRefresh] = useState(0);
   const { dispatch: windowDispath } = useWindowContext();

   useEffect(() => {
      var interval: NodeJS.Timeout;
      function runOnInterval() {
         props.jobService.JobStatus(props.job.id).then((status) => {
            setJobStatus(status);
            if (status.status !== "running") {
               clearInterval(interval);
            }
         });
      }
      interval = setInterval(runOnInterval, 2000);
      return () => clearInterval(interval);
   }, [refresh]);

   useEffect(() => {
      if (jobStatus?.status !== "running" && jobStatus?.id) {
         props.jobService.JobResult(jobStatus.id).then((files) => {
            setDownload(files || []);
         });
         props.jobService.JobHasTaskList(jobStatus.id).then((hasDb) => {
            setTaskListAccess(hasDb.hasTaskDb);
         });
      }
   }, [jobStatus])

   function handleDeletePopup(jobId: string) {
      windowDispath(openWindow(WindowId.ConfirmationDialog, {
         header: "Delete Job",
         children: Localization.getText("Are you sure you want to delete this job?"),
         onSubmit: async () => {
            await props.jobService.RemoveJob(jobId);
            props.callBack?.();
         }
      }));
   }


   function downloadFile(jobId: string, file: string) {
      props.jobService.JobResult(jobId, file).then((blob) => {
         ExportData.downloadBlob(file, blob);
      });
   }

   return (
      <div className={"JobDetail " + jobStatus?.status} >
         {jobStatus ? (
            <>
               <div className="title">{jobStatus.name} '{jobStatus.type}'
                  {jobStatus.status == "scheduled" && (
                     <Refresh
                        size="16"
                        style={{
                           marginLeft: "8px",
                           color: "#4b7ccb",
                           verticalAlign: "middle"
                        }}
                     />
                  )}
               </div>
               <div className="userInfo">{Localization.getText("Create by")} : <div data-userref={jobStatus.userRef}>{" " + jobStatus.userName}</div></div>
               <div className="infoContainer">
                  <div className="infoAlign">
                     <div className="info">Status : {Localization.getText(upperCaseFirstChar(jobStatus.status))}</div>
                     <div className="info">{Localization.getText("Created")} : <div className="infoDate">{new Date(jobStatus.created).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}</div></div>
                     {jobStatus.started ? <div className="info">{Localization.getText("Started")} : <div className="infoDate">{new Date(jobStatus.started).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}</div></div> : <></>}
                     {jobStatus.finished && jobStatus.status !== "running" ? <div className="info">{Localization.getText("Finished")} : <div className="infoDate">{new Date(jobStatus.finished).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}</div></div> : <></>}
                     {jobStatus.estimatedEnd && jobStatus.status == "running" ? <div className="info">{Localization.getText("Estimated")} : <div className="infoDate">{jobStatus.estimatedEnd ? new Date(jobStatus.estimatedEnd).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : ""}</div></div> : <></>}
                  </div>
                  {jobStatus.status == "running" ? <div className="statusMsg">{jobStatus.statusMsg || ""}</div> : <></>}
               </div>
               <JobProgress taskInvalid={jobStatus.taskInvalid} taskXXX={jobStatus.taskXXX} taskDone={jobStatus.taskDone} taskFailed={jobStatus.taskFailed} taskTotal={jobStatus.taskTotal} />
               {jobStatus.status == "scheduled" && <CountdownProgressBar nextRun={jobStatus.nextRun} status={jobStatus.status} finished={jobStatus.finished} />}
               <GlassButtonRow wrap>
                  {jobStatus.status !== "running" && <GlassButton onClick={async () => { (await props.jobService.StartJob(jobStatus?.id)); setRefresh((a) => a + 1) }} >{Localization.getText("Start")}</GlassButton>}
                  {jobStatus.status == "running" || jobStatus.status == "scheduled" && <GlassButton onClick={async () => { (await props.jobService.StopJob(jobStatus?.id)); setRefresh((a) => a + 1) }} >{Localization.getText("Stop")}</GlassButton>}
                  {<GlassButton onClick={async () => { handleDeletePopup(jobStatus.id) }} >{Localization.getText("Delete")}</GlassButton>}
                  {props.admin && <GlassButton onClick={async () => { (await props.jobService.ResetJob(jobStatus?.id)); props.callBack?.() }} >Reset</GlassButton>}
                  {<GlassButton onClick={() => windowDispath(openWindow(WindowId.JobServiceLog, { jobId: jobStatus.id }))} >{Localization.getText("Log")}</GlassButton>}
                  {props.admin && <GlassButton onClick={() => setRefresh((a) => a + 1)} >Refresh</GlassButton>}
                  {props.admin && <>
                     {jobStatus.mailTo.includes(sessionState.userRef)
                        ?
                        <GlassButton onClick={async () => { (await props.jobService.unsubscribe(jobStatus.id, sessionState.userRef)); setRefresh((a) => a + 1) }} >unSub</GlassButton>
                        :
                        <GlassButton onClick={async () => { (await props.jobService.subscribe(jobStatus.id, sessionState.userRef, Localization.getLanguage() as "da" | "en")); setRefresh((a) => a + 1) }} >Sub</GlassButton>
                     }
                  </>}
                  {taskListAccess ? <GlassButton onClick={() => windowDispath(openWindow(WindowId.JobServiceTaskList, { jobId: jobStatus.id, jobName: jobStatus.name }))} >{Localization.getText("Task list")}</GlassButton> : <></>}
                  {download.length ? <GlassButtonDropdown options={download.map((a) => ({ value: a, text: a }))} onSelect={(val) => { downloadFile(props.job.id, val) }} >{Localization.getText("Download")}</GlassButtonDropdown> : <></>}
                  {props.admin && <GlassButton onClick={() => windowDispath(openWindow(WindowId.JobServiceMailExample, { job: jobStatus }))} >Mail Example</GlassButton>}
               </GlassButtonRow>
            </>
         ) : <>Loading <Spinner variant="success" /> </>}
      </div>
   )
}

export function JobServiceMailExample(props: { window: ManagedWindow }) {
   const { dispatch: windowDispath } = useWindowContext();
   let job: JobStatus = props.window.windowParams.job;

   const mailTitle = `Mapit Job ${job.name} er ${job.status === "failed" ? "fejlet" : "afsluttet"}. ${job.taskFailed ? "Nogle beregninger fejlede" : ""}`
   const mailString = `
   <div style="width: fit-content; margin: auto;">
   <h2 style="text-align: left;">Mapit Job Afsluttet</h1>
   <div style="margin: auto; padding: 15px; border: 1px solid #333333; border-radius: 10px;">
   <div>JobId ${job.id}</div>
   <div>Started ${new Date(job.started).toLocaleString("da-dk")} af ${job.userName} (${job.userRef})</div>
   <div>Afsluttet ${new Date(job.finished).toLocaleString("da-dk")}</div>
   <div>Antal linjer ${job.taskTotal}</div>
   <div>Antal linjer færdige ${job.taskDone}</div>
   <div>Antal linjer fejlede ${job.taskFailed}</div>

   <div>Gå til <a href="https://mapit4.viamap.net">Mapit</a> for at tilgå jobbet</div>
   <div>Ved spørgsmål kontakt <a href="mailto:support@viamap.net">support@viamap.ner</a></div>

   <div>Denne mail er sendt automatisk</div>
   </div>
   </div>
   `;







   return (
      <AdvancedDragModal window={props.window} onClose={() => windowDispath(closeWindow(props.window.id))} PosDefault={{ left: "20%", top: "20%", width: "550px", height: "750px" }} title={mailTitle} >
         <ADModalBody>
            <div dangerouslySetInnerHTML={{ __html: mailString }} />
         </ADModalBody>
      </AdvancedDragModal>
   )
}

//#region Job Service Log

export function JobServiceLog(props: { window: ManagedWindow }) {
   const { state: sessionState } = useContext(SessionContext)
   const [jobService] = useState<JobServiceInterface>(new JobServiceInterface({
      organizationId: sessionState.customerRef,
      userName: sessionState.userName,
      userRef: sessionState.userRef,
      languageCode: Localization.getLanguage() as "da" | "en"
   }));
   const [log, setLog] = useState<string | undefined>(undefined);
   const scrollRef = useRef<HTMLDivElement>(null);
   const [autoUpdate, setAutoUpdate] = useState(false);
   const [files, setFiles] = useState<string[]>([]);
   const { dispatch: windowDispath } = useWindowContext();
   const { hasAccessToFeature } = useContext(ApplicationStateContext);

   function refreshLog() {
      if (props.window.windowParams["jobId"]) {
         jobService.JobLog(props.window.windowParams.jobId).then((log) => {
            setLog(log);
         });
      }
   }

   useEffect(() => {
      if (props.window.windowParams["jobId"]) {
         jobService.DebugFile(props.window.windowParams.jobId).then((files) => {
            setFiles(files);
         });
      }


   }, [props.window.windowParams.jobId])



   useEffect(() => {
      if (scrollRef.current) {
         scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
   }, [log]);

   useEffect(() => {
      if (autoUpdate) {
         let interval = setInterval(refreshLog, 2000);
         return () => clearInterval(interval);
      }
   }, [autoUpdate])

   useEffect(() => {
      refreshLog();
   }, [props.window.windowParams.jobId])

   return (<AdvancedDragModal window={props.window}
      onClose={() => windowDispath(closeWindow(props.window.id))}
      PosDefault={{ left: "20%", top: "20%", width: "550px", height: "750px" }}
      title="Log"
      subHeaderContent={
         <>
            {hasAccessToFeature(Feature.JobModuleGlobalAdmin) && files.length ? <GlassButtonDropdown options={files.map((a) => ({ value: a, text: a }))} onSelect={async (val) => { ExportData.downloadBlob(val.split("/").at(-1) || "", await jobService.DebugFile(props.window.windowParams.jobId, val)) }} >Filer</GlassButtonDropdown> : <></>}
            {autoUpdate ? <></> : <ViewButtonText onClick={() => refreshLog()}>{Localization.getText("Refresh")}</ViewButtonText>}
            <ViewButtonCheck checked={autoUpdate} onCheck={(e, val) => setAutoUpdate(!val)} >{Localization.getText("Auto refresh")}</ViewButtonCheck>
         </>
      }
   >
      <ADModalBodyNoScroll templateRows={"auto"}>
         <div ref={scrollRef} style={{ flex: "1", overflowY: "auto", paddingInline: "10px", marginRight: "20px", height: "100%", width: "calc(100% - 5px)", color: "black" }} >
            {log ? log.split("\n").map((line, i) => {
               let date = new Date(line.split(" : ")[0]).toLocaleString(undefined, { timeStyle: "short", dateStyle: "short" });
               let msg = line.split(" : ").splice(1).join(" : ");
               if (line.split(" : ").length < 2) {
                  return <Fragment key={i} ></Fragment>
               }
               return <div key={i} style={{ marginBlock: "6px", paddingInline: "10px", borderInline: "2px solid #bbb" }}><div style={{ fontFamily: "Noto Sans Mono", color: "#666" }}>{date}</div><div style={{ paddingLeft: "10px", fontFamily: "Poppins" }}>{msg}</div></div>
            }) : <h1 style={{ color: "orange" }} >No log</h1>}
         </div>
      </ADModalBodyNoScroll>
   </AdvancedDragModal>)
}

//#region Create Job

export function JobServiceJobCreator(props: { window: ManagedWindow }) {
   const { dispatch: windowDispath } = useWindowContext();

   return (
      <AdvancedDragModal window={props.window}
         onClose={() => windowDispath(closeWindow(props.window.id))}
         PosDefault={{ left: "20%", top: "20%", width: "550px" }}
         title={Localization.getText("Create job")}
      >
         <JobInstantiateDialog onCreate={() => {
            props.window?.windowParams["callback"]();
            windowDispath(closeWindow(props.window.id));
         }} />

      </AdvancedDragModal>)

}

//#region Task List

export function JobServiceTaskList(props: { window: ManagedWindow }) {
   const [nextGroupIdx, setNextGroupIdx] = useState(0);
   const [statusToShow, setStatusToShow] = useState<"xxx" | "invalid" | "error" | "all">("all");
   const { state: sessionState } = useContext(SessionContext)
   const [jobService] = useState<JobServiceInterface>(new JobServiceInterface({
      organizationId: sessionState.customerRef,
      userName: sessionState.userName,
      userRef: sessionState.userRef,
      languageCode: Localization.getLanguage() as "da" | "en"
   }));
   const jobId = props.window.windowParams["jobId"]
   const jobName = props.window.windowParams["jobName"]
   const [taskList, setTaskList] = useState<any[]>([]);
   const { dispatch: windowDispath } = useWindowContext();


   useEffect(() => {
      const abortController = new AbortController();

      jobService.JobTaskList(jobId, nextGroupIdx, statusToShow === "all" ? undefined : statusToShow).then((list) => {
         if (abortController.signal.aborted) return;
         let taskList: { id: number, name: string, success?: number, failed?: number, invalid?: number, xxx?: number, total: number }[] = [];
         list.forEach((task) => {
            let exist = taskList.findIndex((a) => a.id === task.groupIdx);
            if (exist > -1) {
               taskList[exist][task.status] = task["Count(idx)"];
               taskList[exist].total += task["Count(idx)"]
               return;
            }
            taskList.push({ id: task.groupIdx, name: task.groupName, [task.status]: task["Count(idx)"], total: task["Count(idx)"] });
         });
         if (abortController.signal.aborted) return;
         setTaskList(taskList);
      });
      return () => abortController.abort();
   }, [jobId, nextGroupIdx, statusToShow]);





   return (
      <AdvancedDragModal window={props.window} onClose={() => windowDispath(closeWindow(props.window.id))} PosDefault={{ left: "20%", top: "20%", width: "550px", height: "750px" }} title={jobName || "Task List"}
         subHeaderContent={
            <>
               <ViewButtonDropdown options={[{ text: statusToText("all"), value: "all" }, { text: statusToText("xxx"), value: "xxx" }, { text: statusToText("invalid"), value: "invalid" }, { text: statusToText("error"), value: "error" }].filter((a) => a.value !== statusToShow)} onSelect={(val) => setStatusToShow(val)} >{statusToText(statusToShow)}</ViewButtonDropdown>
               <ViewButtonText disabled={nextGroupIdx <= 0} onClick={() => setNextGroupIdx((a) => Math.max(a - 240, 0))} >{"<<<"}</ViewButtonText>
               <ViewButtonTextInput value={nextGroupIdx + 1} onChange={(val) => setNextGroupIdx(parseInt(val) - 1)} />
               <ViewButtonText onClick={() => setNextGroupIdx(() => (taskList.at(-1)?.id ?? -1) + 1)} >{">>>"}</ViewButtonText>
            </>
         }
      >
         <ADModalBodyNoScroll templateRows={"auto"}>
            <div className="TaskListItemContainer">
               {taskList.map((task) => (
                  <Fragment key={task.id}>
                     <TaskListItem {...task} onClick={() => windowDispath(openWindow(WindowId.JobServiceTaskInfo, { jobId: jobId, taskId: task.id, name: task.name }))} />
                  </Fragment>
               ))}
            </div>
         </ADModalBodyNoScroll>
      </AdvancedDragModal>
   )
}

function statusToText(msg: string) {
   return {
      "all": Localization.getText("All"),
      "xxx": Localization.getText("XXX"),
      "invalid": Localization.getText("Invalid"),
      "error": Localization.getText("Error")
   }[msg] || msg;
}

export function TaskListItem(props: { id: number, name: string, xxx?: number, invalid?: number, success?: number, error?: number, total: number, onClick: () => void }) {
   return (
      <div className="TaskListItem" onClick={props.onClick}>
         <div>{(props.id + 1).toLocaleString()}</div>
         <div>{props.name}</div>
         <JobProgress taskXXX={props.xxx} taskInvalid={props.invalid} taskDone={props.total} taskFailed={props.error || 0} taskTotal={props.total} />
      </div>
   )
}

//#region Task Info
export function JobServiceTaskInfo(props: { window: ManagedWindow }) {
   const { state: sessionState } = useContext(SessionContext)
   const [jobService] = useState<JobServiceInterface>(new JobServiceInterface({
      organizationId: sessionState.customerRef,
      userName: sessionState.userName,
      userRef: sessionState.userRef,
      languageCode: Localization.getLanguage() as "da" | "en"
   }));
   const jobId = props.window.windowParams["jobId"];
   const taskId = props.window.windowParams["taskId"];
   const name = props.window.windowParams["name"];
   const [settings, setSettings] = useState<any>("'Test\\n'");
   const [info, setInfo] = useState<any[]>([]);
   // const {state: sessionState} = useContext(SessionContext)
   const { dispatch: windowDispath } = useWindowContext();

   useEffect(() => {
      jobService.JobGetSettings(jobId).then((settings) => {
         setSettings(settings);
      });
      jobService.JobTaskInfo(jobId, taskId).then((info: any[]) => {
         setInfo(info);
      });
   }, [jobId, taskId]);


   return (
      <AdvancedDragModal window={props.window} onClose={() => windowDispath(closeWindow(props.window.id))} PosDefault={{ left: "35%", top: "35%", width: "550px", height: "550px" }} title={name || "Task Info"}>
         <ADModalBody>
            <GlassContainer title={Localization.getText("Input settings")} >
               <div style={{ fontSize: "0.8em", overflow: "hidden", padding: "3px" }}>
                  <JsonViewer parsedJson={settings} key={""} level={0} />
               </div>
            </GlassContainer>
            {info.map((subTask) => {
               let infoT = (JSON.parse(subTask.info || "[]") || []).map(SubTaskInfoMsg);

               return (
                  <GlassContainer key={subTask.idx} title={<><div>{subTask.taskName}</div><div>{infoT}</div></>} className={subTask.status + "JobTask" + " flexHead"} >
                     <div style={{ padding: "5px" }}>
                        <AddToMapitButtons spatial={subTask.spatial} nameSuffix={name + (info.length > 1 ? "_" + subTask.taskName : "")} />
                     </div>
                     <RejseplanRoute spatial={subTask.spatial} />
                     <GlassContainer title={Localization.getText("Task input")} >
                        <div style={{ fontSize: "0.8em", overflow: "hidden", padding: "3px" }}>
                           <JsonViewer parsedJson={subTask.input ? JSON.parse(subTask.input) : { message: "No Input" }} key={""} level={0} />
                        </div>
                     </GlassContainer>
                     <GlassContainer title={Localization.getText("Task geometries")} >
                        <div style={{ fontSize: "0.8em", overflow: "hidden", padding: "3px" }}>
                           <JsonViewer parsedJson={subTask.spatial ? JSON.parse(subTask.spatial) : { message: "No Input" }} key={""} level={0} />
                        </div>
                     </GlassContainer>
                     <GlassContainer title={Localization.getText("Task result")} >
                        <div style={{ fontSize: "0.8em", overflow: "hidden", padding: "3px" }}>
                           <JsonViewer parsedJson={subTask.result ? JSON.parse(subTask.result) : { message: "No result" }} key={""} level={0} />
                        </div>
                     </GlassContainer>
                     <GlassContainer title={Localization.getText("Task extra")} >
                        <div style={{ fontSize: "0.8em", overflow: "hidden", padding: "3px" }}>
                           <JsonViewer parsedJson={subTask.debug ? JSON.parse(subTask.debug) : { message: "No debug" }} key={""} level={0} />
                        </div>
                     </GlassContainer>
                  </GlassContainer>
               )
            })}
         </ADModalBody>
      </AdvancedDragModal>
   )
}

function AddToMapitButtons(props: { spatial: string, nameSuffix?: string }) {
   const { dispatch: mapitDispatch } = useContext(MapitStateContext);
   const parsed = JSON.parse(props.spatial || "{}");
   const keys = Object.keys(parsed);


   function onCreateLayer(title: string, visible: boolean, features: any[], propertiesToShow?: string[]) {
      Persistence.createLayersFromGeoJSON(title, featureCollection(features), new Date(), (li: LayerInfo) => {
         li.visible = visible;
         li.propertiesToDisplay = (propertiesToShow || LayerFunc.extractPropertiesFromGeoJSON(featureCollection(features))).reduce<any[]>((result, prop) => {
            return [...result, { name: prop }];
         }, []);
         li.propertiesInGeoJson = LayerFunc.extractPropertiesFromGeoJSON(featureCollection(features));
         li.styling = { ...li.styling, ...Webrejsestyle(features) } as any;
         mapitDispatch(actionAddDataLayer(li, true));
      })
   }


   function Webrejsestyle(features: { properties: { Type: string } }[]): LayerInfoStyling {
      let uniqueFeature = [...new Set(features.map((a) => a.properties.Type))];

      return {
         "color": "#4b7ccb",
         "opacity": 1,
         "textByProperty": ["Navn", "Id"],
         "colorByProperty": "Type",
         "colorByValue": {
            "useColorRange": 3,
            "dataColumn": 0,
            "divisions": {
               "type": 1,
               "list": uniqueFeature.map((a) => ({
                  "from": null,
                  "to": null,
                  "value": a,
                  "count": features.filter((b) => b.properties.Type === a).length,
                  "color": transporttypeColor(a) || "rgb(255,255,255)"
               })),
               "otherValuesCount": 0
            },
            "divisionStylingType": 0
         },
         "outsideColorRange": {
            "show": true,
            "color": "lightgreen"
         }
      }
   };


   return (
      <GlassButtonRow>
         {keys.map((key) => (
            <GlassButton key={key} onClick={() => onCreateLayer(key + ((props.nameSuffix && "_" + props.nameSuffix) || ""), true, extractToFeatureArray(parsed[key]))} >{key}</GlassButton>
         ))}
      </GlassButtonRow>
   )
}

//#region Extra Components

function JobProgress(props: { taskDone: number, taskFailed: number, taskTotal: number, taskInvalid?: number, taskXXX?: number, add?: boolean }) {
   if (props.taskTotal === 0) {
      return <></>
   }


   let invalidWidth = props.taskInvalid || 0;
   let failedWidth = (props.taskFailed || 0) + invalidWidth;
   let xxxWidth = (props.taskXXX || 0) + failedWidth;
   let doneWidth = props.add ? (props.taskDone || 0) + xxxWidth : (props.taskDone || 0);

   return (
      <>
         <div className="JobProgress">
            <div className="jobProgress-bar">
               <div className="jobProgress" style={{ position: "absolute", height: "100%", backgroundColor: "lightgreen", width: `${doneWidth / props.taskTotal * 100}%` }} >{props.taskDone}</div>
               {props.taskXXX ? <div className="jobProgress" style={{ position: "absolute", height: "100%", backgroundColor: "orange", width: `${xxxWidth / props.taskTotal * 100}%` }} >{props.taskXXX}</div> : <></>}
               {props.taskFailed ? <div className="jobProgress" style={{ position: "absolute", height: "100%", backgroundColor: "tomato", width: `${failedWidth / props.taskTotal * 100}%` }} >{props.taskFailed}</div> : <></>}
               {props.taskInvalid ? <div className="jobProgress" style={{ position: "absolute", height: "100%", backgroundColor: "red", width: `${invalidWidth / props.taskTotal * 100}%` }} >{props.taskInvalid}</div> : <></>}
               {props.taskTotal}
            </div>
            <div className="jobProgressInfoContainer"  >
               <div className="jobProgressInfo"  >
                  <div style={{ color: "#90ee90" }}>{Localization.getText("Done")}: {doneWidth}</div>
                  {props.taskFailed ? <div style={{ color: "#90ee90" }}>{Localization.getText("Failed")}: {props.taskFailed}</div> : <></>}
                  {props.taskInvalid ? <div style={{ color: "#90ee90" }}>{Localization.getText("Invalid")}: {props.taskInvalid}</div> : <></>}
                  {props.taskXXX ? <div style={{ color: "#90ee90" }}>{Localization.getText("XXX")}: {props.taskXXX}</div> : <></>}
                  <div style={{ color: "#90ee90" }}>{Localization.getText("Total")}: {props.taskTotal}</div>
               </div>
            </div>
         </div>
      </>
   )
}




function CountdownProgressBar({ nextRun, status, finished }: { nextRun: string, status: string, finished?: string }) {
   const [timeLeft, setTimeLeft] = useState<number>(0);
   const [totalTime, setTotalTime] = useState<number>(0);
   const targetTimeRef = useRef<number>(0);

   useEffect(() => {
      if (!nextRun) return;

      const nextRunTime = new Date(nextRun).getTime();
      const now = new Date().getTime();
      const timeDiff = nextRunTime - now;

      if (timeDiff <= 0) {
         setTimeLeft(0);
      } else {
         setTimeLeft(timeDiff);
      }

      if (finished) {
         const finishedTime = new Date(finished).getTime();
         const totalIntervalMs = nextRunTime - finishedTime;
         setTotalTime(totalIntervalMs);
      } else {
         const intervalMinutes = 5;
         const totalIntervalMs = intervalMinutes * 60 * 1000;
         setTotalTime(totalIntervalMs);
      }

      targetTimeRef.current = nextRunTime;

      const interval = setInterval(() => {
         const currentTime = new Date().getTime();
         const remaining = targetTimeRef.current - currentTime;

         if (remaining <= 0) {
            setTimeLeft(0);
            const newTargetTime = new Date().getTime() + totalTime;
            targetTimeRef.current = newTargetTime;
            setTimeLeft(totalTime);
         } else {
            setTimeLeft(remaining);
         }
      }, 1000);

      return () => clearInterval(interval);
   }, [nextRun, finished, totalTime]);

   if (!nextRun) {
      return null;
   }

   const progress = timeLeft > 0 ? Math.max(0, Math.min(100, ((totalTime - timeLeft) / totalTime) * 100)) : 100;
   const minutes = Math.floor(timeLeft / 60000);
   const seconds = Math.floor((timeLeft % 60000) / 1000);

   const getBarColor = () => {
      if (status === "scheduled") return "#4CAF50";
      return "#ff6b6b";
   };

   return (
      <div className="JobProgress">
         <div className="jobProgress-bar">
            <div
               className="jobProgress"
               style={{
                  position: "absolute",
                  height: "100%",
                  backgroundColor: getBarColor(),
                  width: `${progress}%`,
                  transition: "width 1s linear"
               }}
            >
               {timeLeft > 0 ? `${minutes}:${seconds.toString().padStart(2, '0')}` : "Restarting..."}
            </div>
         </div>
         <div className="jobProgressInfoContainer">
            <div className="jobProgressInfo">
               <div style={{ color: "#90ee90" }}>
                  {timeLeft > 0 ?
                     (status === "scheduled" ? "Next run:" : "Restart in:") + " " + new Date(nextRun).toLocaleTimeString() :
                     "Restarting job..."
                  }
               </div>
               <div style={{ color: "#90ee90" }}>
                  {timeLeft > 0 ? `Time left: ${minutes}:${seconds.toString().padStart(2, '0')}` : "Please wait..."}
               </div>
            </div>
         </div>
      </div>
   );
}



function upperCaseFirstChar(str: string) {
   return str.charAt(0).toUpperCase() + str.slice(1);
}

function extractToFeatureArray(ft: any) {
   if (ft.type === "Feature") {
      return [ft];
   } else if (ft.type === "FeatureCollection") {
      return ft.features;
   } else {
      return [];
   }
}

function SubTaskInfoMsg(a: any) {
   let split = a.split(":")
   let type = split.at(0).trim();
   let rest = split.slice(1).join(":").trim();
   switch (type) {
      case "info":
         return <div>{rest}</div>
      case "err":
         return <div>{rest}</div>
      default:
         return <div>{rest}</div>
   }
}